import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppObserver from "./observer/AppObserver";
import LinklerSayfasi from "./admin/LinklerSayfasi";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/observer" element={<AppObserver />} />
      <Route path="/board" element={<AppObserver />} />
      {/* 2026-08-16: DISC katılımcı linkleri — Someren Labs temsilcisi için */}
      <Route path="/linkler" element={<LinklerSayfasi />} />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();
